export default "__VITE_ASSET__b06c8817__"